import { call, select } from 'redux-saga/effects';
import { RootState } from '../../..';
import { IApiRequestConfig, TApiResponse } from '../types';
import { fetchApiAsync } from './fetchApiAsync';

export function* fetchApi(config: IApiRequestConfig): Generator {
  const jwt = yield select((state: RootState) => state.access.jwt);
  const locale = (yield select((state: RootState) => state.ui.locale)) as string;

  const result = (yield call(
    fetchApiAsync as any,
    {
      ...config,
      query: {
        ...config.query,
        locale,
      },
    },
    jwt
  )) as Partial<TApiResponse>;
  return result;
}
